/** @fileoverview Project filter for the student "My tasks" list (default: all). */

import { Select } from '@mantine/core'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ALL_PROJECTS, SKELETON } from '../constants'

export interface ProjectOption {
  readonly value: string
  readonly label: string
}

interface StudentTasksFiltersProps {
  projects: readonly ProjectOption[]
  value: string
  onChange: (projectId: string) => void
  disabled?: boolean
}

export function StudentTasksFilters({
  projects,
  value,
  onChange,
  disabled = false,
}: StudentTasksFiltersProps) {
  const { t } = useTranslation()

  const data = useMemo(
    () => [{ value: ALL_PROJECTS, label: t('student_tasks.cards.all_projects') }, ...projects],
    [projects, t],
  )

  return (
    <Select
      data={data}
      value={value || ALL_PROJECTS}
      onChange={v => onChange(v ?? ALL_PROJECTS)}
      searchable
      clearable={value !== ALL_PROJECTS}
      disabled={disabled}
      style={{ width: SKELETON.filter.width, maxWidth: '100%' }}
      aria-label={t('student_tasks.cards.project')}
    />
  )
}
